import ContactsContainer from './ContactsContainer.jsx'

export {ContactsContainer}



// WEBPACK FOOTER //
// ./pages/contacts/index.js